import { render, staticRenderFns } from "./oauth.vue?vue&type=template&id=71fa7a33"
import script from "./oauth.vue?vue&type=script&lang=js"
export * from "./oauth.vue?vue&type=script&lang=js"
import style0 from "./oauth.vue?vue&type=style&index=0&id=71fa7a33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports